import { connect } from 'react-redux';
import { setNegotiationAction, showPaymentModal } from 'project/ducks/project_1_1';
import { fetchProject } from 'project/ducks/project';
import { fetchMessagesIfNeeded } from 'common/ducks/message';
import BriefHead1_1 from 'project/components/brief/head_1_1';

const mapStateToProps = (state) => {
  const project1To1 = state.project.projectPage.project1To1
  return {
    selectedCreative: project1To1.selectedCreative,
    negotiationAction: project1To1.negotiationAction
  }
}

export default connect(mapStateToProps, {
  setNegotiationAction,
  fetchProject,
  fetchMessagesIfNeeded,
  showPaymentModal
})(BriefHead1_1);



// WEBPACK FOOTER //
// ./project/containers/brief_head_1_1.jsx